export const baseUrl =
    process.env.NODE_ENV === 'production' ?
        process.env.VUE_APP_REALEASE === 'test' ?
            'http://gw-test.mini1.cn/api/' :
            'https://www.mini1.cn/api/' :
        '/api/';